import COLOR from "../../constants/colors";

const styles = {
  votesTag: {
    color: COLOR.darkGreen,
    width: 40,
    textAlign: "center",
    paddingTop: 5,
    paddingBottom: 5,
  },
};
export default styles;
